<template>
    <div class="flex justify-between">
        <a @click="$emit('updateAudit', audit, $event)">
            <ion-text color="primary">
                Modifica
                <ion-icon :icon="createOutline"></ion-icon>
            </ion-text>
        </a>
        <a @click="$emit('deleteAudit', audit, $event)">
            <ion-text color="danger">
                Elimina
                <ion-icon :icon="trashOutline"></ion-icon>
            </ion-text>
        </a>
    </div>
    <div class="mei-formset-accordion-field-group">
        <small class="mei-formset-accordion-label muted">Area</small>
        <span class="mei-formset-accordion-label-content">{{ audit.area }}</span>
    </div>
    <div class="mei-formset-accordion-field-group">
        <small class="mei-formset-accordion-label muted">Tipologia dispositivo</small>
        <span class="mei-formset-accordion-label-content">{{ trap!.device_type }}</span>
    </div>
    <div class="mei-formset-accordion-field-group">
        <small class="mei-formset-accordion-label muted">Caratteristica</small>
        <span class="mei-formset-accordion-label-content">{{ trap!.characteristic }}</span>
    </div>
    <div class="mei-formset-accordion-field-group">
        <small class="mei-formset-accordion-label muted">Principio attivo</small>
        <span class="mei-formset-accordion-label-content">{{ trap!.active_substance }}</span>
    </div>
</template>

<script setup lang="ts">
import {computed, PropType} from "vue";
import {IAudit} from "@/types/audit";
import {useTrapsStore} from "@/stores/traps";
import {createOutline, trashOutline} from "ionicons/icons";
import {IonIcon, IonText} from "@ionic/vue";

const props = defineProps({
    audit: {
        type: Object as PropType<IAudit>,
        required: true,
    }
});
const trapsStore = useTrapsStore();
const trap = computed(() => trapsStore.getTrapById(props.audit!.trap));
defineEmits(['updateAudit', 'deleteAudit']);
</script>
